/* eslint-disable global-require */
import EDC from '@/components/games/shared/globals';

/**
 *
 */
EDC.Games.GameTypePicker.Scenes.Preloader = function () {};
/**
 *
 */
EDC.Games.GameTypePicker.Scenes.Preloader.prototype.create = function () {
  this.load.on('complete', this.onLoadImagesComplete, this);
  this.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/views/GameTypePicker/');

  this.load.image('background', 'Background.jpg');
  this.load.image('title-frame', 'title-frame.png');
  this.load.image('frame', 'Frame.png');
  this.load.image('frame-hover', 'Frame_Hover.png');
  this.load.image('auto-icon', 'Icon_Auto.png');
  this.load.image('pick-icon', 'Icon_Pick.png');
  this.load.image('rpg-icon', 'Icon_RPG.png');
  this.load.image('auto-label', 'Label_Auto.png');
  this.load.image('pick-label', 'Label_Pick.png');
  this.load.image('rpg-label', 'Label_RPG.png');
  this.load.image('start-title', 'Title_Start.png');
  this.load.image('logo', '../../OrbUp_Logo.png');

  this.load.setPath();
  this.load.start();
};
/**
 *
 */
EDC.Games.GameTypePicker.Scenes.Preloader.prototype.onLoadImagesComplete = function () {
  this.load.off(this.onLoadImagesComplete, this);
  this.scene.start('GameTypePicker-Main');
};

export default EDC.Games.GameTypePicker.Scenes.Preloader;
